define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/action/FormData",
	"csi/def/Action",
	"csi/gallery/Widget",
	"csi/session",
	"csi/state"
], function(declare,lang,Controller,FormData,Action,Gallery,session,state) {

	var	_falseFunc = function() {
		return false;
	};

	return declare(Gallery, {
		// Boolean: disable links in view since entire block will be anchor
		bForceBrowse: false,

		postCreate: function() {
			// summary: setup view to allow node selection
			if (!state.get("print")) {
				var	controller = new Controller({
					m_action: new Action(),
					m_element: this.domNode,
					widget: this
				});

				this.defView.setFormData(lang.mixin(new FormData(controller), {
					m_bSelectOne: true
				}));
			}

			this.inherited(arguments);
		},

		onSelect: function(/*Context*/ctx, /*String*/url, /*Boolean*/bOn, /*Boolean*/bReplaced) {
			// summary: extension point for view selections
			if (bOn) {
				session.setLocationUrl(url);
			}
		}
	});
});